import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedAuthors === undefined ||
  widgetSetting.includedAuthors === null ||
  widgetSetting.includedAuthors.length === 0

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) =>
  insights.length > applicationSettings.analysisMaxAuthors

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedAuthors: insights.map((insight) => ({
    name: insight.name || insight.authorName,
    authorName: insight.name ? undefined : insight.authorName,
    authorID: insight.authorID,
    domain: insight.domain
  }))
})

const generateIncludedAuthorsStrategy = (
  applicationSettings: any
): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateIncludedAuthorsStrategy
